import React from 'react';
import './App.css';
import ChordProgressionGenerator from './components/ChordProgressionGenerator';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="app-main">
        <ChordProgressionGenerator />
      </main>
      <Footer />
    </div>
  );
}

export default App; 